export enum PaymentStatus {
    PENDING = 'pending',
    AUTHORIZED = 'authorized',
    FAILED = 'failed',
    REFUNDED = 'refunded',
}
